module.exports = __webpack_public_path__ + "static/media/DE.7f9ab154.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/DE.svg
// module id = 237
// module chunks = 0